import { Injectable, inject } from '@angular/core';
import { AppBase } from '@app/shared/models/app-base';
import { BaseParamsService } from '@app/core/base-params.service';

@Injectable()
export class LegalDocumentsService {
  private baseParamsService = inject(BaseParamsService);


  public getPrivacyPolicyHref(): string {
    const rootURI = this.baseParamsService.getRootURI();

    if (rootURI === '/') {
      return `${AppBase.href}/privacy-policy`;
    } else {
      return `${AppBase.href}${rootURI}/privacy-policy`;
    }
  }

  public getCookiePolicyHref(): string {
    const rootURI = this.baseParamsService.getRootURI();

    if (rootURI === '/') {
      return `${AppBase.href}/cookie-policy`;
    } else {
      return `${AppBase.href}${rootURI}/cookie-policy`;
    }
  }
}
